/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAssessed = /* GraphQL */ `query GetAssessed($ID: Int!) {
  getAssessed(ID: $ID) {
    ID
    AssessmentID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessedQueryVariables,
  APITypes.GetAssessedQuery
>;
export const listAssesseds = /* GraphQL */ `query ListAssesseds($AssessmentID: Int) {
  listAssesseds(AssessmentID: $AssessmentID) {
    ID
    AssessmentID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessedsQueryVariables,
  APITypes.ListAssessedsQuery
>;
export const getAssessment = /* GraphQL */ `query GetAssessment($ID: Int!) {
  getAssessment(ID: $ID) {
    ID
    Title
    BranchID
    Assessor
    Created
    TrainingType
    AssessmentDetailID
    Conditions
    Results
    Reference
    IsTemplate
    Location
    Scenario
    QuarterlyAssessmentDetailID
    StartDate
    EndDate
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentQueryVariables,
  APITypes.GetAssessmentQuery
>;
export const listAssessments = /* GraphQL */ `query ListAssessments(
  $WantsQuarterlyOnly: Boolean
  $WantsTemplatesOnly: Boolean
) {
  listAssessments(
    WantsQuarterlyOnly: $WantsQuarterlyOnly
    WantsTemplatesOnly: $WantsTemplatesOnly
  ) {
    ID
    Title
    BranchID
    AssessorName
    AssessorID
    AssessorEmail
    TaskNumbers
    Created
    TrainingType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentsQueryVariables,
  APITypes.ListAssessmentsQuery
>;
export const getAssessmentDetail = /* GraphQL */ `query GetAssessmentDetail($ID: Int!) {
  getAssessmentDetail(ID: $ID) {
    ID
    Conditions
    Results
    Reference
    AssessmentID
    IsTemplate
    Location
    Scenario
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentDetailQueryVariables,
  APITypes.GetAssessmentDetailQuery
>;
export const listAssessmentDetails = /* GraphQL */ `query ListAssessmentDetails {
  listAssessmentDetails {
    ID
    Conditions
    Results
    Reference
    AssessmentID
    IsTemplate
    Location
    Scenario
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentDetailsQueryVariables,
  APITypes.ListAssessmentDetailsQuery
>;
export const getAssessmentTask = /* GraphQL */ `query GetAssessmentTask($ID: Int!) {
  getAssessmentTask(ID: $ID) {
    ID
    AssessmentID
    TaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentTaskQueryVariables,
  APITypes.GetAssessmentTaskQuery
>;
export const listAssessmentTasks = /* GraphQL */ `query ListAssessmentTasks($AssessmentID: Int!) {
  listAssessmentTasks(AssessmentID: $AssessmentID) {
    ID
    AssessmentID
    TaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentTasksQueryVariables,
  APITypes.ListAssessmentTasksQuery
>;
export const getAssessmentTaskPerformanceStep = /* GraphQL */ `query GetAssessmentTaskPerformanceStep($ID: Int!) {
  getAssessmentTaskPerformanceStep(ID: $ID) {
    ID
    ATID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentTaskPerformanceStepQueryVariables,
  APITypes.GetAssessmentTaskPerformanceStepQuery
>;
export const listAssessmentTaskPerformanceSteps = /* GraphQL */ `query ListAssessmentTaskPerformanceSteps($ATID: Int!) {
  listAssessmentTaskPerformanceSteps(ATID: $ATID) {
    ID
    ATID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentTaskPerformanceStepsQueryVariables,
  APITypes.ListAssessmentTaskPerformanceStepsQuery
>;
export const getAssessmentTaskSubTaskPerformanceStep = /* GraphQL */ `query GetAssessmentTaskSubTaskPerformanceStep($ID: Int!) {
  getAssessmentTaskSubTaskPerformanceStep(ID: $ID) {
    ID
    ATSTID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentTaskSubTaskPerformanceStepQueryVariables,
  APITypes.GetAssessmentTaskSubTaskPerformanceStepQuery
>;
export const listAssessmentTaskSubTaskPerformanceSteps = /* GraphQL */ `query ListAssessmentTaskSubTaskPerformanceSteps($ATSTID: Int!) {
  listAssessmentTaskSubTaskPerformanceSteps(ATSTID: $ATSTID) {
    ID
    ATSTID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentTaskSubTaskPerformanceStepsQueryVariables,
  APITypes.ListAssessmentTaskSubTaskPerformanceStepsQuery
>;
export const getAssessmentTaskSubTask = /* GraphQL */ `query GetAssessmentTaskSubTask($ID: Int!) {
  getAssessmentTaskSubTask(ID: $ID) {
    ID
    AssessmentTaskID
    SubTaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAssessmentTaskSubTaskQueryVariables,
  APITypes.GetAssessmentTaskSubTaskQuery
>;
export const listAssessmentTaskSubTasks = /* GraphQL */ `query ListAssessmentTaskSubTasks($ATID: Int!) {
  listAssessmentTaskSubTasks(ATID: $ATID) {
    ID
    AssessmentTaskID
    SubTaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAssessmentTaskSubTasksQueryVariables,
  APITypes.ListAssessmentTaskSubTasksQuery
>;
export const getBranch = /* GraphQL */ `query GetBranch($UnitID: Int!, $UnitDepth: Int!) {
  getBranch(UnitID: $UnitID, UnitDepth: $UnitDepth) {
    ID
    SiteID
    __typename
  }
}
` as GeneratedQuery<APITypes.GetBranchQueryVariables, APITypes.GetBranchQuery>;
export const listBranchs = /* GraphQL */ `query ListBranchs {
  listBranchs {
    ID
    SiteID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBranchsQueryVariables,
  APITypes.ListBranchsQuery
>;
export const getBranchUser = /* GraphQL */ `query GetBranchUser($UserID: String!, $BranchID: Int!) {
  getBranchUser(UserID: $UserID, BranchID: $BranchID) {
    ID
    BranchID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBranchUserQueryVariables,
  APITypes.GetBranchUserQuery
>;
export const listBranchUsers = /* GraphQL */ `query ListBranchUsers {
  listBranchUsers {
    ID
    BranchID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBranchUsersQueryVariables,
  APITypes.ListBranchUsersQuery
>;
export const getMET = /* GraphQL */ `query GetMET($ID: Int!) {
  getMET(ID: $ID) {
    ID
    Name
    TaskID
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMETQueryVariables, APITypes.GetMETQuery>;
export const listMETs = /* GraphQL */ `query ListMETs {
  listMETs {
    ID
    Name
    TaskID
    __typename
  }
}
` as GeneratedQuery<APITypes.ListMETsQueryVariables, APITypes.ListMETsQuery>;
export const getPerformanceStep = /* GraphQL */ `query GetPerformanceStep($ID: Int!) {
  getPerformanceStep(ID: $ID) {
    ID
    Name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPerformanceStepQueryVariables,
  APITypes.GetPerformanceStepQuery
>;
export const listPerformanceSteps = /* GraphQL */ `query ListPerformanceSteps {
  listPerformanceSteps {
    ID
    Name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPerformanceStepsQueryVariables,
  APITypes.ListPerformanceStepsQuery
>;
export const getQuarterlyAssessmentDetail = /* GraphQL */ `query GetQuarterlyAssessmentDetail($ID: Int!) {
  getQuarterlyAssessmentDetail(ID: $ID) {
    ID
    StartDate
    EndDate
    AssessmentID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQuarterlyAssessmentDetailQueryVariables,
  APITypes.GetQuarterlyAssessmentDetailQuery
>;
export const listQuarterlyAssessmentDetails = /* GraphQL */ `query ListQuarterlyAssessmentDetails {
  listQuarterlyAssessmentDetails {
    ID
    StartDate
    EndDate
    AssessmentID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQuarterlyAssessmentDetailsQueryVariables,
  APITypes.ListQuarterlyAssessmentDetailsQuery
>;
export const getRank = /* GraphQL */ `query GetRank($ID: String!) {
  getRank(ID: $ID) {
    ID
    Value
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRankQueryVariables, APITypes.GetRankQuery>;
export const listRanks = /* GraphQL */ `query ListRanks {
  listRanks {
    ID
    Value
    __typename
  }
}
` as GeneratedQuery<APITypes.ListRanksQueryVariables, APITypes.ListRanksQuery>;
export const getSite = /* GraphQL */ `query GetSite($ID: Int!) {
  getSite(ID: $ID) {
    ID
    Name
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSiteQueryVariables, APITypes.GetSiteQuery>;
export const listSites = /* GraphQL */ `query ListSites {
  listSites {
    ID
    Name
    __typename
  }
}
` as GeneratedQuery<APITypes.ListSitesQueryVariables, APITypes.ListSitesQuery>;
export const getSiteUser = /* GraphQL */ `query GetSiteUser($ID: Int!) {
  getSiteUser(ID: $ID) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSiteUserQueryVariables,
  APITypes.GetSiteUserQuery
>;
export const listSiteUsers = /* GraphQL */ `query ListSiteUsers {
  listSiteUsers {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSiteUsersQueryVariables,
  APITypes.ListSiteUsersQuery
>;
export const getSiteAdmin = /* GraphQL */ `query GetSiteAdmin($ID: Int!) {
  getSiteAdmin(ID: $ID) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSiteAdminQueryVariables,
  APITypes.GetSiteAdminQuery
>;
export const listSiteAdmins = /* GraphQL */ `query ListSiteAdmins {
  listSiteAdmins {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSiteAdminsQueryVariables,
  APITypes.ListSiteAdminsQuery
>;
export const getSubTask = /* GraphQL */ `query GetSubTask($ID: Int!) {
  getSubTask(ID: $ID) {
    ID
    ParentID
    ChildID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubTaskQueryVariables,
  APITypes.GetSubTaskQuery
>;
export const listSubTasks = /* GraphQL */ `query ListSubTasks {
  listSubTasks {
    ID
    ParentID
    ChildID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubTasksQueryVariables,
  APITypes.ListSubTasksQuery
>;
export const getSubmitToken = /* GraphQL */ `query GetSubmitToken($ID: Int!) {
  getSubmitToken(ID: $ID) {
    ID
    Token
    Time
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubmitTokenQueryVariables,
  APITypes.GetSubmitTokenQuery
>;
export const listSubmitTokens = /* GraphQL */ `query ListSubmitTokens {
  listSubmitTokens {
    ID
    Token
    Time
    UserID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubmitTokensQueryVariables,
  APITypes.ListSubmitTokensQuery
>;
export const getTask = /* GraphQL */ `query GetTask($ID: Int!) {
  getTask(ID: $ID) {
    ID
    Name
    Number
    Level
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTaskQueryVariables, APITypes.GetTaskQuery>;
export const listTasks = /* GraphQL */ `query ListTasks {
  listTasks {
    ID
    Name
    Number
    Level
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTasksQueryVariables, APITypes.ListTasksQuery>;
export const getTaskPerformanceStep = /* GraphQL */ `query GetTaskPerformanceStep($ID: Int!) {
  getTaskPerformanceStep(ID: $ID) {
    ID
    TaskID
    PSID
    SequenceNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaskPerformanceStepQueryVariables,
  APITypes.GetTaskPerformanceStepQuery
>;
export const listTaskPerformanceSteps = /* GraphQL */ `query ListTaskPerformanceSteps {
  listTaskPerformanceSteps {
    ID
    TaskID
    PSID
    SequenceNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskPerformanceStepsQueryVariables,
  APITypes.ListTaskPerformanceStepsQuery
>;
export const getUnit = /* GraphQL */ `query GetUnit($BranchID: Int, $ID: Int) {
  getUnit(BranchID: $BranchID, ID: $ID) {
    ID
    Depth
    Name
    LeaderID
    ParentUnitID
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUnitQueryVariables, APITypes.GetUnitQuery>;
export const listUnits = /* GraphQL */ `query ListUnits {
  listUnits {
    ID
    Depth
    Name
    LeaderID
    ParentUnitID
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUnitsQueryVariables, APITypes.ListUnitsQuery>;
export const getUnitBranch = /* GraphQL */ `query GetUnitBranch($ID: Int!) {
  getUnitBranch(ID: $ID) {
    ID
    UnitID
    BranchID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUnitBranchQueryVariables,
  APITypes.GetUnitBranchQuery
>;
export const listUnitBranchs = /* GraphQL */ `query ListUnitBranchs {
  listUnitBranchs {
    ID
    UnitID
    BranchID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUnitBranchsQueryVariables,
  APITypes.ListUnitBranchsQuery
>;
export const getUnitTask = /* GraphQL */ `query GetUnitTask($ID: Int!) {
  getUnitTask(ID: $ID) {
    ID
    UnitID
    TaskID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUnitTaskQueryVariables,
  APITypes.GetUnitTaskQuery
>;
export const listUnitTasks = /* GraphQL */ `query ListUnitTasks {
  listUnitTasks {
    ID
    UnitID
    TaskID
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUnitTasksQueryVariables,
  APITypes.ListUnitTasksQuery
>;
export const getUser = /* GraphQL */ `query GetUser($ID: String!) {
  getUser(ID: $ID) {
    ID
    Rank
    Name
    Email
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers {
  listUsers {
    ID
    Rank
    Name
    Email
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
